import React, { useState } from "react";
import { Helmet } from "react-helmet";

function Enquiry() {
  const [result, setResult] = useState("");
  const [showModal, setShowModal] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Submitting your request, please wait...");
    setShowModal(true);
    const formData = new FormData(event.target);
    formData.append("access_key", "19816bbd-afc4-43ae-a34a-31c599ca13a8");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Thank you! Your enquiry has been successfully submitted. We will get back to you shortly.");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult("Oops! Something went wrong. Please try again later.");
    }
  };
  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune to Mumbai Cab",
    "description": "Book your comfortable Pune to Mumbai cab for a smooth and hassle-free journey. Choose from one-way, round trip, and group travel options with both affordable and luxury cabs.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "450"
    }
  };
  return (
    <div>

          <Helmet>
          <title>Pune to Mumbai Cab | S9 Travels | Contact: +91 8850328441</title>
              <meta 
                name="description" 
                content="Book a reliable cab for your Pune to Mumbai journey. Affordable and luxury cabs available for one-way, round-trip, and group travel services." 
              />
              {/* Inject JSON-LD Schema */}
              <script type="application/ld+json">
                {JSON.stringify(productSchema)}
              </script>
            </Helmet>

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>Enquiry</h1>
        </div>
      </div>
    </section>
       

      <section className="contact-form-section">
        <div className="contact-form-container">
          <h2 className="contact-form-title text-white">Get in Touch with Us</h2>
          <form onSubmit={onSubmit}
          name="contactForm"
          id="contact_form"
          className="contact-form"
          action="send_email.php"
          method="post"
          data-redirect="c"
        >
          <div className="contact-form-row">
            <div className="contact-form-group">
              <label htmlFor="name" className="contact-form-label">Your Full Name</label>
              <input
                type="text"
                name="name"
                id="name"
                className="contact-form-input"
                placeholder="Your Full Name"
                required
                pattern="[A-Za-z\s]+"
                title="Name must contain only letters"
              />
            </div>
            <div className="contact-form-group">
              <label htmlFor="phone" className="contact-form-label">Your Contact Number</label>
              <input
                type="tel"
                name="phone"
                id="phone"
                className="contact-form-input"
                placeholder="Your Contact Number"
                required
                pattern="[0-9]{10}"
                title="Phone number must be of 10 digits"
              />
            </div>
          </div>
         
          <div className="contact-form-row">


        
            
            <div className="contact-form-group">
              <label htmlFor="pick_up_point" className="contact-form-label">Pick Up Point</label>
              <input
                type="text"
                name="pick_up_point"
                id="pick_up_point"
                className="contact-form-input"
                placeholder="Pick Up Point"
                required
                pattern="[A-Za-z\s]+"
                title="Pick Up Point must contain only letters"
              />
            </div>

            <div className="contact-form-group">
              <label htmlFor="pick_up_point" className="contact-form-label">Dropoff Location</label>
              <input
                type="text"
                name="dropoff_location"
                id="dropoff_location"
                className="contact-form-input"
                placeholder="Dropoff Location"
                required
                pattern="[A-Za-z\s]+"
                title="Pick Up Point must contain only letters"
              />
            </div>
          </div>
        

<div className="contact-form-row">
          <div className="contact-form-group">
            <label htmlFor="date" className="contact-form-label">Date of Journey</label>
            <input
              type="date"
              name="date"
              id="date"
              className="contact-form-input"
              placeholder="Date of Journey"
              required
            />
          </div>

          <div className="contact-form-group">
              <label htmlFor="days" className="contact-form-label">Number of Passengers</label>
              <input
                type="number"
                name="days"
                id="days"
                className="contact-form-input"
                placeholder="Number of Passengers"
                required
                min="1"
                max="100"
                step="1"
              />
            </div>

            </div>
          <div className="contact-form-group">
            <textarea
              name="message"
              id="message"
              className="contact-form-textarea"
              placeholder="Your Message"
              required
            ></textarea>
          </div>
          <div className="contact-form-recaptcha">
            <div className="g-recaptcha" data-sitekey="copy-your-site-key-here"></div>
          </div>
          <div className="contact-form-submit">
            <input
              type="submit"
              id="send_message"
              value="Submit Now"
              className="default-btn border-0"
            />
          </div>
        </form>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlayy">
          <div className="modal">
            <p>{result}</p>
            <button onClick={() => setShowModal(false)} className="modal-close-btn">OK</button>
          </div>
        </div>
      )}

      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 50%;
          height: 50%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .modal {
          background: white;
          padding: 20px;
          border-radius: 5px;
          text-align: center;
        }
        .modal-close-btn {
          margin-top: 10px;
          padding: 5px 10px;
          border: none;
          background: #007bff;
          color: white;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
}

export default Enquiry;
